export const sets = [
  {
    code: 'dmu',
    name: 'Dominaria United',
    path: '/articles/cube-prospective-dominaria-united/',
    iconURL: 'https://svgs.scryfall.io/sets/dmu.svg?1655092800',
  },
  {
    code: 'dmc',
    name: 'Dominaria United Commander',
    path: '/articles/cube-prospective-dominaria-united-commander/',
    iconURL: 'https://svgs.scryfall.io/sets/dmc.svg?1655092800',
  },
  {
    code: 'bro',
    name: "The Brother's War",
    path: '/articles/cube-prospective-the-brothers-war/',
    iconURL: 'https://svgs.scryfall.io/sets/bro.svg?1655092800',
  },
  {
    code: 'brc',
    name: "The Brothers' War Commander",
    path: '/articles/cube-prospective-the-brothers-war-commander/',
    iconURL: 'https://svgs.scryfall.io/sets/brc.svg?1655092800',
  },
  {
    code: 'unf',
    name: 'Unfinity',
    path: '/articles/cube-prospective-unfinity/',
    iconURL: 'https://svgs.scryfall.io/sets/unf.svg?1655092800',
  },
  {
    code: '40k',
    name: 'Warhammer 40,000',
    path: '/articles/cube-prospective-warhammer-40-000/',
    iconURL: 'https://svgs.scryfall.io/sets/40k.svg?1655092800',
  },
  {
    code: 'j22',
    name: 'Jumpstart 2022',
    path: '/articles/cube-prospective-jumpstart-2022/',
    iconURL: 'https://svgs.scryfall.io/sets/j22.svg?1655092800',
  },
  {
    code: 'one',
    name: 'Phyrexia: All Will Be One',
    path: '/articles/cube-prospective-phyrexia-all-will-be-one/',
    iconURL: 'https://svgs.scryfall.io/sets/one.svg?1655092800',
  },
  {
    code: 'onc',
    name: 'Phyrexia: All Will Be One Commander',
    path: '/articles/cube-prospective-phyrexia-all-will-be-one-commander/',
    iconURL: 'https://svgs.scryfall.io/sets/onc.svg?1655092800',
  },
  {
    code: 'mom',
    name: 'March of the Machine',
    path: '/articles/cube-prospective-march-of-the-machine/',
    iconURL: 'https://svgs.scryfall.io/sets/mom.svg?1655092800',
  },
  {
    code: 'moc',
    name: 'March of the Machine Commander',
    path: '/articles/cube-prospective-march-of-the-machine-commander/',
    iconURL: 'https://svgs.scryfall.io/sets/moc.svg?1655092800',
  },
  {
    code: 'mat',
    name: 'March of the Machine: The Aftermath',
    path: '/articles/cube-prospective-march-of-the-machine-the-aftermath/',
    iconURL: 'https://svgs.scryfall.io/sets/mat.svg?1655092800',
  },
  {
    code: 'ltr',
    name: 'Lord of the Rings: Tales of Middle-earth',
    path: '/articles/cube-prospective-lord-of-the-rings-tales-of-middle-earth/',
    iconURL: 'https://svgs.scryfall.io/sets/mom.svg?1655092800',
  },
  {
    code: 'ltc',
    name: 'Tales of Middle-earth Commander',
    path: '/articles/cube-prospective-tales-of-middle-earth-commander/',
    iconURL: 'https://svgs.scryfall.io/sets/ltc.svg?1655092800',
  },
]
